export default __webpack_public_path__ + "recordAngloApp.html";